import {useAnimation, useMotionValue, motion} from "framer-motion";
import React, {useEffect} from "react";
import {getRandomEmoji, spring} from "../lib/utils";

interface EmojiItemProps {
  symbol: string;
  x: number;
  y: number;
  rotate: number;
  [key: string]: any;
}

function EmojiItem(
  {symbol, x, y, rotate, ...position}: EmojiItemProps,
  i: number
) {
  const controls = useAnimation();
  const emoji = useMotionValue(symbol);
  const change = useMotionValue(true);

  useEffect(() => {
    controls.start({
      opacity: 1,
      x,
      y,
      rotate,
      transition: {
        ...spring.bouncy,
        delay: i % 2 ? 0.015 * i : i * -0.025,
      },
    });
  }, [controls]);

  function resetPos() {
    controls.start({x, y, rotate: rotate + 360});
  }

  return (
    <motion.div
      key={i}
      className="absolute z-10 pointer-events-auto cursor-grab active:cursor-grabbing"
      tabIndex={-1}
      style={position}
      transition={{
        ...spring.bouncy,
        rotate: {...spring.bouncy, stiffness: 100},
      }}
      whileHover={{
        scale: (position.scale ?? 1) + 0.2,
        rotate: rotate * -Math.random(),
      }}
      onTap={() => change.get() && emoji.set(getRandomEmoji())}
      onDragStart={() => change.set(false)}
      onDragEnd={() => {
        setTimeout(() => change.set(true), 0);
        resetPos();
      }}
      dragElastic={0.1}
      whileTap={{scale: position.scale ?? 1, transition: {duration: 0}}}
      initial={{opacity: 0}}
      exit={{opacity: 0, transition: {duration: 0.1}}}
      animate={controls}
      drag
    >
      <motion.span className="text-7xl select-none">{emoji}</motion.span>
    </motion.div>
  );
}

function Emoji() {
  const items = [
    {
      symbol: "📦",
      top: 50,
      left: 150,
      x: -20,
      y: -110,
      rotate: -12,
      scale: 1.4,
    },
    {symbol: "😲", top: 200, left: 50, x: -170, y: -50, rotate: -20},
    {
      symbol: "🧑‍🍳",
      bottom: 150,
      left: 50,
      x: -100,
      y: 100,
      rotate: -20,
      scale: 1.4,
    },
    {
      symbol: getRandomEmoji(),
      top: 100,
      right: 90,
      x: 170,
      y: -170,
      rotate: 20,
    },
    {
      symbol: "😋",
      right: "7%",
      top: "40%",
      x: 190,
      y: 20,
      rotate: 10,
      scale: 1.4,
    },
    {symbol: "🍽️", right: "7%", bottom: "20%", x: 120, y: 70, rotate: 15},
  ];

  return (
    <>
      {items.map((item, i) => (
        <EmojiItem {...item} key={i} />
      ))}
    </>
  );
}

export {Emoji};
